import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import ChoiceFields from './ChoiceFields'

export const ChoiceCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <ChoiceFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default ChoiceCreate
